import { Form, Formik } from "formik";
import FormControl from "@mui/material/FormControl";
import { TextField, CircularProgress, Tabs, Tab } from "@mui/material";
import SearchComponent from "../../../components/OB/SearchComponent";
import TableComponent from "../../../components/OB/TableComponent";
import { useState } from "react";
import KutuphaneTakipAPI, { KutuphaneTakipRequest } from "../../../apis/OB/Get/KutuphaneTakipAPI";
import { showToast } from "../../../helpers/ToastifyHelper";
import * as Yup from "yup";

const validationSchema = Yup.object({
});


const EKutuphaneTakip: React.FC = () => {
    const [uyeNo, setUyeNo] = useState<number | "">("");
    const [vatandaslikNo, setVatandaslikNo] = useState("");
    const [sicilKodu, setSicilKodu] = useState<number | "">("");

    const [data, setData] = useState<any[]>([]);
    const [isSearched, setIsSearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [searchControl, setSearchControl] = useState<boolean>(true);

    const columns = [
        { header: "Üye No", field: "uyeNo", className: "text-center" },
        { header: "Vatandaşlık No", field: "vatandaslikNo", className: "text-center" },
        { header: "Sicil Kodu", field: "sicilKodu", className: "text-center" },
        { header: "Kayıt No", field: "kayitNo", className: "text-center" },
        { header: "Adı", field: "adi", className: "text-center" },
        { header: "Soyadı", field: "soyadi", className: "text-center" },
        { header: "Eser Adı", field: "eserAdi", className: "text-center" },
        { header: "Yazar Adı", field: "yazarAdi", className: "text-center" },
        { header: "Alma Tarihi", field: "almaTarihi", className: "text-center" },
        { header: "Teslim Tarihi", field: "teslimTarihi", className: "text-center" },
    ];

    const fetchData = async () => {
        if (!sicilKodu || !vatandaslikNo || !uyeNo) {
            showToast("Lütfen tüm alanları doldurun!", "error");
            setSearchControl(false);
            return;
        }

        setIsLoading(true);
        try {
            const req = new KutuphaneTakipRequest(
                uyeNo,
                vatandaslikNo,
                sicilKodu
            );
            const response = await KutuphaneTakipAPI.KutuphaneTakip(req);
            console.log("API yanıtı:", response);

            const rows: any[] = response?.data ?? [];

            if (rows.length > 0) {
                const first = rows[0];
                if (first.sonuc === 1) {
                    showToast(first.sonucAciklama, "warning");
                    setData([]);
                } else {
                    setData(rows);
                }
            } else {
                showToast("Kayıt bulunamadı", "warning");
                setData([]);
            }
            setIsSearched(true);
        } catch (err) {
            console.error(err);
            showToast("Hata oluştu", "error");
            setSearchControl(false);
            setData([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleTemizle = () => {
        setSicilKodu("");
        setVatandaslikNo("");
        setData([]);
        setIsSearched(false);
        setSearchControl(true);
    };


    return (
        <div className="px-1 px-md-2 px-lg-4 py-3 card w-100">
            <div className="card-body p-0">
                <Formik
                    initialValues={{
                        uyeNo: "",
                        vatandaslikNo: "",
                        sicilKodu: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={() => { }}
                >
                    <Form id="kayit-form" className="d-flex w-100 mb-4">
                        <div className="d-flex flex-column flex-sm-row w-100 gap-3 ml-2 mr-2">
                            <div className="d-flex flex-column flex-sm-row gap-2 w-100">
                                <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                                    <TextField
                                        label="Sicil Kodu"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        value={sicilKodu}
                                        error={!sicilKodu && searchControl === false}
                                        color={!sicilKodu && searchControl === false ? "error" : "primary"}
                                        onChange={e => {
                                            const v = e.target.value;
                                            setSicilKodu(v === "" ? "" : Number(v));
                                        }}
                                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                                    />
                                </FormControl>
                                <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                                    <TextField
                                        label="T.C. Kimlik No"
                                        variant="outlined"
                                        size="small"
                                        value={vatandaslikNo}
                                        error={!vatandaslikNo && searchControl === false}
                                        color={!vatandaslikNo && searchControl === false ? "error" : "primary"}
                                        onChange={(e) => setVatandaslikNo(e.target.value)}
                                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                                    />
                                </FormControl>
                                <FormControl sx={{ width: { xs: "100%", sm: "50%", md: "25%" }, minWidth: 140 }}>
                                    <TextField
                                        label="Kütüphane Üye No"
                                        variant="outlined"
                                        size="small"
                                        type="number"
                                        value={uyeNo}
                                        error={!uyeNo && searchControl === false}
                                        color={!uyeNo && searchControl === false ? "error" : "primary"}
                                        onChange={e => {
                                            const v = e.target.value;
                                            setUyeNo(v === "" ? "" : Number(v));
                                        }}
                                        sx={{ "& .MuiOutlinedInput-root": { backgroundColor: "white" } }}
                                    />
                                </FormControl>
                            </div>
                            <div className="d-flex flex-row ms-auto">
                                <SearchComponent fetchData={fetchData} onTemizle={handleTemizle} setData={setData} />
                            </div>
                        </div>
                    </Form>
                </Formik>

                {isLoading ? (
                    <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: "10rem" }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <TableComponent columns={columns} data={data} recordsPerPage={10} isSearched={isSearched} />
                )}
            </div>
        </div>
    );
};

export default EKutuphaneTakip;
